import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Grid, TextField, MenuItem, Button, Avatar } from "@mui/material";
import { LocalTaxiRounded, ScheduleRounded, ChecklistRtlRounded } from "@mui/icons-material";

// Components
import ChatApp from "../../Header/Bell_icon";

// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";

const Dispatcherhead = ({setSelectedstatus , setSelectedservice , selectedservice , userType }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [services, setservices] = useState([]);

    const profiledetails = useSelector(
        (state) => state?.ProfileSettingsReducer?.profiledetails?.image
      );

    const handleSelectedServiceDrivers = (event) => {
        setSelectedservice(event.target.value);
      };
    
      const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");

      const getservicesanddrivers = useCallback(() => {
        dispatch(showLoader("Loading please wait..."));
        const data = {};
      
        const onSuccess = (res) => {
          dispatch(hideLoader());
          if (res?.data?.status === true) {
            setservices(res?.data?.data?.serviceTypeDetails);
            console.log("fetched services--->", res?.data?.data?.serviceTypeDetails);
          } else {
            setservices([]);
          }
        };
        const onFailure = (err) => {
          dispatch(hideLoader());
          dispatch(
            showSnackbar({
              message: err?.response?.data?.message || "Failed to fetch service and drivers data",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "error",
            })
          );
        };
        DispatcherApi.getdriversandservices(data).then(onSuccess, onFailure);
      }, []);

    useEffect(() => {
        getservicesanddrivers();
      }, []);  

    return (
      <>

<Grid container alignItems="center" spacing={2} className={classes.dispatcherheader} >     
      {/* Vehicle Category Selector */}
      <Grid item>
        <TextField
          select
          label="Vehicle Category"
          onChange={handleSelectedServiceDrivers}
          value={selectedservice || ""}
          variant="outlined"
          size="small"
          sx={{
            marginLeft:"50px",
            minWidth: 180,
            "& .MuiOutlinedInput-root": {
              borderRadius: "30px",
              backgroundColor: "#f5f6f8",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#e0e0e0",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#999",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#4dabf7",
            },
          }}
        >
          {services?.map((service) => (
            <MenuItem key={service._id} value={service._id}>
              {service.serviceName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

{/* Status Filters - Pill Style Buttons */}
<Grid item>
<Button 
  variant="contained" 
  startIcon={<LocalTaxiRounded />} 
  onClick={()=>{setSelectedstatus('ACTIVE')}}
  sx={{ 
    borderRadius: "25px", 
    backgroundColor: "#30e356", 
    color: "#fff", 
    textTransform: "none",
    padding: "8px 20px",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#28c44d",
    }
  }}
>
    Active
</Button>
<Button 
  variant="outlined" 
  startIcon={<LocalTaxiRounded />} 
  onClick={()=>{setSelectedstatus('OFFLINE')}}
  sx={{ 
    borderRadius: "25px", 
    color: "#ef4444",
  backgroundColor: "rgba(239, 68, 68, 0.12)",   // 🔥 soft transparent red
  "& .MuiSvgIcon-root": {
    color: "#ef4444",
  },

    // border:"solid 1px #f44336",
    border:"none",
    textTransform: "none",
    padding: "8px 20px",
    marginLeft: 1,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#d32f2f",
      color:"#fff",
      border:"solid 1px #d32f2f",
       "& .MuiSvgIcon-root": {
    color: "#fff",
  },
    }
  }}
>
    Offline
</Button>
<Button 
  variant="outlined" 
  startIcon={<LocalTaxiRounded />} 
  onClick={()=>{setSelectedstatus('RIDING')}}
  sx={{ 
    borderRadius: "25px", 
    // backgroundColor: "#68b2fb", 
    color: "#68b2fb", 
  backgroundColor: "rgba(59, 130, 246, 0.12)",  // 🔥 soft blue transparent
  "& .MuiSvgIcon-root": {
    color: "#3b82f6",
  },
 
     border:"none",
    textTransform: "none",
    padding: "8px 20px",
    marginLeft: 1,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#0363c9",
      color:"#fff",
      border:"solid 1px #0363c9",
      "& .MuiSvgIcon-root": {
    color: "#fff",
  },
    }
  }}
>
    Riding
</Button>
</Grid>

{/* Dashboard and Actions */}
<Grid item sx={{ marginLeft: "auto" }}>
<Button 
  variant="contained" 
  onClick={()=>{navigate('/dashboard')}}
  sx={{ 
    borderRadius: "25px", 
    backgroundColor: "#ff41b4", 
    color: "#fff", 
    textTransform: "none",
    padding: "8px 20px",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#e639a3",
    }
  }}
>
    Admin Dashboard
</Button>

<Button 
  variant="outlined"
  onClick={()=>{navigate('/triplist')}}
  sx={{ 
    borderRadius: "25px", 

    color: "#717070", 
    textTransform: "none",
    padding: "8px 20px",
    marginLeft: 1,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#333",
      color:"#fff"
    }
  }}
>
    Trip List
</Button>

</Grid>

{/* bell icon */}

<Grid item>
{userType !== "SUB COMPANY" && (
<ChatApp/>
)}
</Grid>

{/* User Profile */}
<Grid item sx={{marginRight:"50px"}}>
<Avatar src={profiledetails} alt="User" />
</Grid>
</Grid>  
      </>
    );
  };
  
  export default Dispatcherhead;
